import { Container } from "reactstrap";

export default function NoMatch () {
  return (
    <Container>404</Container>
  )
}
